import React from 'react';
import { Provider } from 'react-redux';

import {  MuiThemeProvider } from '@material-ui/core/styles';
import { BrowserRouter as Router } from 'react-router-dom';

import Root from './Root.js';

const App = ({ store, theme }) => (
  <Provider store={store}>
    <MuiThemeProvider theme={theme}>
        <Router>
          <Root/>
        </Router>
    </MuiThemeProvider>
  </Provider>
)

export default App;
